const tabbedContent = (): void => {
  const classes = {
    activeTab: 'tab--active',
    activeContent: 'content--active',
  };

  const selectors = {
    tabbedContent: '[data-tabbed-content]',
    tab: '[data-tab]',
    nav: '[data-nav]',
    content: '[data-content]',
    select: '[data-select]',
    tabID: 'data-tab',
    contentID: 'data-content',
    navID: 'data-nav',
  };

  const tabbedContentSections = document.querySelectorAll<HTMLElement>(
    selectors.tabbedContent
  );

  if (tabbedContentSections) {
    tabbedContentSections.forEach((section) => {
      const tabs = section.querySelectorAll<HTMLElement>(selectors.tab);
      const contents = section.querySelectorAll<HTMLElement>(selectors.content);
      const navs = section.querySelectorAll<HTMLElement>(selectors.nav);
      const select = section.querySelector<HTMLSelectElement>(selectors.select);

      const scrollToElement = (element: HTMLElement): void => {
        const topOffset = 67;
        const elementPosition =
          element.getBoundingClientRect().top +
          document.documentElement.scrollTop -
          topOffset;
        window.scrollTo(0, elementPosition);
      };

      const openContent = (tabID: string): void => {
        contents.forEach((content) => {
          const contentID = content.getAttribute(selectors.contentID);
          if (contentID == tabID) {
            content.classList.add(classes.activeContent);
          } else {
            content.classList.remove(classes.activeContent);
          }
        });
      };

      const closeTabs = (): void => {
        tabs.forEach((tab) => {
          tab.classList.remove(classes.activeTab);
        });
      };

      const openTab = (tab: HTMLElement): void => {
        tab.classList.add(classes.activeTab);
        const tabID = tab.getAttribute(selectors.tabID);
        openContent(tabID);
      };

      const updateSelect = (optionID: string): void => {
        select.value = optionID;
      };

      const updateTab = (tabID: string): void => {
        tabs.forEach((tab) => {
          const id = tab.getAttribute(selectors.tabID);
          if (id == tabID) {
            tab.classList.add(classes.activeTab);
          } else {
            tab.classList.remove(classes.activeTab);
          }
        });
      };

      select.addEventListener('change', () => {
        updateTab(select.value);
        openContent(select.value);
        scrollToElement(section);
      });

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const tabID = tab.getAttribute(selectors.tabID);
          closeTabs();
          openTab(tab);
          updateSelect(tabID);
          scrollToElement(section);
        });
      });

      navs.forEach((nav) => {
        nav.addEventListener('click', () => {
          const navID = nav.getAttribute(selectors.navID);
          closeTabs();
          openContent(navID);
          updateSelect(navID);
          scrollToElement(section);

          tabs.forEach((tab) => {
            const tabID = tab.getAttribute(selectors.tabID);
            if (tabID == navID) {
              tab.classList.add(classes.activeTab);
            }
          });
        });
      });
    });
  }
};

export default tabbedContent;
